import store from 'localforage'
import urlJoin from 'url-join'
import qs from 'qs'

import config from '../config.js'

let tokenKey = 'token'
let tokenStore = store.createInstance({
  name: 'tokens'
})

const tokenBase = {
  get isExpired () {
    return this.expiresAt * 1000 < Date.now()
  }
}

const makeToken = token => Object.assign(Object.create(tokenBase), token)
const exists = (obj) => obj !== undefined && obj !== null

export function login () {
  let href = urlJoin(config.oAuth.authorization, '?' + qs.stringify({
    ...config.oAuth,
    nonce: '1',
    state: '1'
  }))
  window.location.href = href
}

export function logout () {
  return tokenStore.removeItem(tokenKey)
}

export function checkForToken () {
  // Parse the token
  return tokenStore.getItem(tokenKey)
    .then(result => {
      if (exists(result)) return result
      //if (exists(result)) logout()
      let token = parseRedirectToken(window.location.hash)
      if (token) {
        window.location.hash = ''
        token = unpackEncodedToken(token)
        return exists(token) ? tokenStore.setItem(tokenKey, token) : null
      }
      return null
    })
    .then(result => {
      if (!result) return
      let token = makeToken(result)
      return token.isExpired ? logout().then(() => undefined) : token
    })
}

function parseRedirectToken (value) {
  if (!value || !value.length) return null
  if (value[0] === '#') value = value.substring(1)

  let token = qs.parse(value)
  if (token.error) {
    let message = `Error logging in: ${token.error_description || 'Unknown Error'}`
    console.log(message)
    throw new Error(message)
  }
  // Check that this is an oauth redirection, not a normal app route
  return token.access_token ? token : null
}

function parseJwtPayload (payload) {
  return JSON.parse(window.atob(payload))
}

function unpackEncodedToken (token) {
  if (!token || !token.access_token) return null

  let accessValues = token.access_token.split('.')
  let openIdValues = token.id_token.split('.')
  let accessClaims = parseJwtPayload(accessValues[1])
  let openIdClaims = parseJwtPayload(openIdValues[1])

  // The name of these values will depend on the token issuer
  // Ping and Okta have different values for scope and username
  return {
    accessToken: token.access_token,
    openIdToken: token.id_token,
    expiresIn: token.expires_in,
    expiresAt: accessClaims.exp,
    username: accessClaims.sub,
    email: openIdClaims.email,
    firstName: openIdClaims.given_name,
    lastName: openIdClaims.family_name,
    scope: accessClaims.scope,
    encoded: token
  }
}



// WEBPACK FOOTER //
// ./client/src/auth/oAuth.js